import { render, staticRenderFns } from "./researchResources.vue?vue&type=template&id=260a5586&scoped=true&"
import script from "./researchResources.vue?vue&type=script&lang=js&"
export * from "./researchResources.vue?vue&type=script&lang=js&"
import style0 from "./researchResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a5586",
  null
  
)

export default component.exports